import React from "react";

const About = () => {
  return (
    <section className="section about-section">
      <h1 className="section-title">About us</h1>
      <p>
        Lorem ipsum dolor sit amet consectetur adipisicing elit. Quia maxime nam
        atque molestias velit odio similique sit impedit consectetur temporibus
        neque sapiente deserunt vero eaque voluptates, dolores debitis pariatur
        ipsam, ex quibusdam eius rem! Consequatur, necessitatibus facilis.
        Nulla, dolore soluta?
      </p>
    </section>
  );
};

export default About;
